import { Injectable } from '@angular/core';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { LabConfigurationService } from '../data-service/lab-configuration.service';
import { OrderCommandService } from '../data-service/order-command.service';
import { SettingsService } from '../data-service/settings.service';
import { OrderShippingDetails } from '../models/shipping/shipping-details-request.model';
import { CurrentOrderService } from '../services/current-order.service';

@Injectable({
    providedIn: 'root'
})
export class ShippingDetailsCleanUpService {

    constructor(
        private orderCommandService: OrderCommandService,
        private labConfigurationService: LabConfigurationService,
        private settingsService: SettingsService,
        private currentOrderService: CurrentOrderService) {
    }

    async CleanupShippingDetails(orderCode: string, labCode: string, orderShippingDetails: OrderShippingDetails, cleanDetails: boolean)
        : Promise<OrderShippingDetails> {

        return new Promise(async (resolve) => {
            this.labConfigurationService.LabCode = labCode;
            const labConfiguration = await this.labConfigurationService.getLabConfiguration().toPromise();
            const eurofinsShipping = (await this.settingsService.getSettingValue(
                SettingsKey.enableShipping
              )).toLowerCase() === 'true';

            if (!labConfiguration.thirdPartyShippingEnabled || !eurofinsShipping) {
                this.orderCommandService.deleteShippingDetails(orderCode).subscribe(data => {
                    this.currentOrderService.currentOrder.shipping = null;
                    this.currentOrderService.currentOrder.selfShipping = true;
                    return resolve(data);
                });
            } else {
                if (cleanDetails) {
                    orderShippingDetails.billingCurrencyCode = null;
                    orderShippingDetails.carrierServiceCode = null;
                    orderShippingDetails.estimatedPrice = null;
                    orderShippingDetails.isReturnShipmentOpted
                        = labConfiguration.returnShipmentSupported && orderShippingDetails.isReturnShipmentOpted;
                    this.orderCommandService.addOrUpdateShippingDetails(orderCode, orderShippingDetails).subscribe(data => {
                        return resolve(data);
                    });
                }
                return resolve();
            }
        });
    }
}
